import type { NapiClient } from "@app/services/api";

export async function getTripSegmentStopsRelated(
  api: NapiClient,
  trip_id: string
) {
  return await api.getTripSegmentStopsRelated(trip_id);
}
